import { mainColor, additionalColor } from "../../root/global";
import styled, { css } from "styled-components";

export const BackToTopButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${mainColor};
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  position: fixed;
  bottom: 30px;
  right: 30px;
  transition: background-color 0.3s, opacity 0.4s, visibility 0.4s,
    transform 0.25s, box-shadow 0.3s;
  z-index: 1000;
  outline: none;
  box-sizing: border-box;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  box-shadow: 0 10px 25px -6px rgba(40, 52, 74, 0.6);

  @media screen and (max-width: 500px) {
    width: 42px;
    height: 42px;
    bottom: 20px;
    right: 20px;
  }

  svg {
    width: 40%;
    height: 40%;

    path {
      fill: #fff;
    }
  }

  ${({ show }) => {
    return show
      ? css`
          visibility: visible;
          opacity: 1;
          transform: translateY(0);
        `
      : null;
  }}

  &:hover {
    cursor: pointer;
    transform: translateY(-4px);
    background-color: ${additionalColor};
    box-shadow: 0 14px 28px -6px rgba(134, 67, 220, 0.6);
  }

  &:active {
    transform: translateY(-1px) scale(0.94);
  }
`;
